export default __webpack_public_path__ + "static/media/html5.6e4a5621.png";